import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { catchError, EMPTY } from 'rxjs';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { ModalService } from '../../../../services/modal.service';
import { UserService } from '../../../../services/user.service';
import { UserStore } from '../../../../stores/user.store';
import { passwordMatchValidator } from '../../../../validators/password-match.validator';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { PasswordInputComponent } from '../../../atoms/password-input/password-input.component';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';

@Component({
  selector: 'app-modal-change-password',
  imports: [ButtonComponent, ModalHeaderComponent, PasswordInputComponent],
  templateUrl: './modal-change-password.component.html',
  styleUrl: './modal-change-password.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalChangePasswordComponent {
  private readonly userService = inject(UserService);
  private readonly userStore = inject(UserStore);
  private readonly modalService = inject(ModalService);

  readonly requestState = signal<RequestStateEnum | null>(null);
  readonly isLoading = computed(() => this.userStore.requestState() === RequestStateEnum.PENDING);

  form = new FormGroup(
    {
      oldPassword: new FormControl<string | null>(null, Validators.required),
      newPassword: new FormControl<string | null>(null, Validators.required),
      confirmNewPassword: new FormControl<string | null>(null, Validators.required),
    },
    {
      validators: passwordMatchValidator('newPassword', 'confirmNewPassword'),
    }
  );

  public updatePassword(): void {
    this.requestState.set(RequestStateEnum.PENDING);

    this.userService
      .updatePassword(this.form.controls.oldPassword.value!, this.form.controls.newPassword.value!)
      .pipe(
        catchError(() => {
          this.requestState.set(RequestStateEnum.PENDING);
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.modalService.close();
      });
  }

  public close(): void {
    this.modalService.close();
  }
}
